import { Flex, Text } from "@chakra-ui/react";
import { NewsCardImage } from "./NewsCardImage";
import { Article, LayoutStyle } from "../../../types";
import { Link } from "react-router-dom";
import { useIsSmallBreakpoint } from "../../../utils/useBreakpoints";
import { toPathname } from "../../../utils/safeParseUrl";
import { CSSProperties } from "react";
import { NewsCardAvatar } from "./NewsCardAvatar";

export function WideNewsCard({
  preview_image_url,
  url,
  title,
  category,
  author,
  size,
  titleFontSize,
}: Article & {
  size: LayoutStyle["size"];
  titleFontSize?: CSSProperties["fontSize"];
}) {
  const isSmallBreakpoint = useIsSmallBreakpoint();

  const isVideoHub = category?.slug === "video-hub";
  let newsDetailsLink = toPathname(url);
  if (isVideoHub) {
    newsDetailsLink = newsDetailsLink.replace("/news", "/watch");
  }

  return (
    <Flex
      width="100%"
      height="100%"
      role="group"
      display="flex"
      gap={size === "xl" ? "40px" : "32px"}
    >
      {size !== "xs" && (
        <Link
          to={newsDetailsLink}
          style={{
            maxWidth: size === "xl" ? "50%" : isVideoHub ? "235px" : "300px",
            width: size === "xl" ? "50%" : undefined,
          }}
        >
          <NewsCardImage
            boxProps={{
              borderRadius: isVideoHub ? "8px" : "16px",
            }}
            imageProps={{
              src: preview_image_url,
              title: title,
              flexShrink: 0,
              objectFit: "contain",
              borderRadius:
                size === "xl" ? "16px" : isVideoHub ? "8px" : "12px",
            }}
          />
        </Link>
      )}
      <Flex direction="column" gap="8px" justifyContent="center" flex={1}>
        {!isVideoHub && category && (
          <Link to={isVideoHub ? `/watch` : `/news/${category.slug}`}>
            <Text
              variant="newsCardVital"
              color="blaze.blaze"
              transition="color .2s linear"
              _hover={{ color: "blaze.300" }}
            >
              {category.display_name}
            </Text>
          </Link>
        )}
        <Text
          as={Link}
          to={newsDetailsLink}
          variant={isVideoHub ? "videoCardTitle" : "newsCardTitle"}
          fontSize={
            titleFontSize ??
            (size === "xl"
              ? "40px"
              : isVideoHub
                ? "20px"
                : isSmallBreakpoint
                  ? "16px"
                  : "24px")
          }
          sx={{
            textDecoration: "underline",
            textDecorationThickness: "0.8px",
            textDecorationColor: "transparent",
            WebkitTextDecorationColor: "transparent",
            MozTextDecorationColor: "transparent",
            transition: "all .2s ease-in",
            _groupHover: {
              textDecorationColor: "dune.dune",
              WebkitTextDecorationColor: "dune.dune",
              MozTextDecorationColor: "dune.dune",
            },
            "-webkit-line-clamp": size === "xl" ? "4" : isVideoHub ? "3" : "2",
          }}
          wordBreak="break-word"
        >
          {title}
        </Text>
        <NewsCardAvatar author={author} isVideoHub={isVideoHub} />
      </Flex>
    </Flex>
  );
}
